// src/router/reg-exp-router/index.ts
import { RegExpRouter } from "./router.js";
export {
  RegExpRouter
};
